@if (!(selectIsGetUpdateChanges$ | ngrxPush)) {
  <div class="view-changes-modal">
    @if (retryStockUpdate && retryExcludeFailedBarcodes) {
      <div class="retry-mode-banner barcode-removal-banner">
        Failed barcodes will be removed from the selected items before this retry is submitted.
      </div>
    } @else if (retryStockUpdate) {
      <div class="retry-mode-banner">
        Review the API event changes below, then confirm to retry the full update.
      </div>
    }
    <div class="view-changes-toolbar">
      <p class="view-changes-count">{{ itemCount }} {{ itemCount === 1 ? 'item' : 'items' }} in this update</p>
      <app-shared-custom-search
        [searchAll]="searchText"
        class="grid-search"
        [placeholder]="'Search code or description…'"
        (searchChange)="onQuickFilterChanged($event)">
      </app-shared-custom-search>
    </div>
    <ag-grid-angular
      (gridReady)="onGridReady($event)"
      (rowSelected)="onSelectionChanged($event)"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowClassRules]="rowClassRules"
      [rowData]="rowData"
      [theme]="'legacy'"
      class="ag-theme-custom">
    </ag-grid-angular>
    <ng-container *ngrxLet="(selectedNotification$ | ngrxPush) as selectedNotification">
      <app-shared-button
        [disabled]="selectedNodes?.length < 1 || (!retryStockUpdate && selectedNotification?.newStockItem)"
        [matTooltip]="!retryStockUpdate && selectedNotification?.newStockItem ? 'Cannot revert new stock items' : ''">
        <div (click)="showModal = true">
          {{ !retryStockUpdate ? 'Revert Changes' : 'Confirm Retry' }}
        </div>
      </app-shared-button>
    </ng-container>
    @if (showModal) {
      <div (click)="showModal = false" class="modal-backdrop"></div>
      <div class="modal-container custom-modal-basic" role="dialog">
        <div class="modal-header">
          <div class="title-container">
            <span>{{ !retryStockUpdate ? 'Revert Stock Edits' : 'Confirm Stock Update Retry' }}</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="context-description">
            @if (!retryStockUpdate) {
              <div>You are about to revert the selected stock edits.</div>
            } @else if (retryExcludeFailedBarcodes) {
              <div class="barcode-removal-heading">You are about to retry the selected stock edits without the failed barcodes.</div>
              <div class="barcode-removal-subheading">Items highlighted in red will have these barcodes removed from the API event:</div>
            } @else {
              <div>You are about to retry the selected stock edits.</div>
            }
            @for (node of uniqueSelectedNodes; track node.rowIndex) {
              <div
                class="confirmation-item"
                [class.barcode-removal-item]="willRemoveBarcodes(node.data.code)">
                <span class="confirmation-item-code">{{ node.data.code }}</span>
                @if (node.data.details?.[1]) {
                  <span class="confirmation-item-description">- {{ node.data.details[1] }}</span>
                }
                @if (willRemoveBarcodes(node.data.code)) {
                  <span class="barcode-removal-note">
                    Barcodes removed: {{ getFailedBarcodes(node.data.code).join(', ') }}
                  </span>
                }
              </div>
            }
            @if (retryStockUpdate && !hasRetryPayload()) {
              <div class="no-retry-payload-banner">
                <app-display-icon
                  class="no-retry-payload-banner-icon"
                  [border]="false"
                  [colour]="iconColourEnum.yellow"
                  [icon]="icons.infoSlabCircleOutline">
                </app-display-icon>
                <div class="no-retry-payload-banner-body">
                  <p class="no-retry-payload-banner-title">Nothing left to retry</p>
                  <p class="no-retry-payload-banner-text">
                    Removing the failed barcodes leaves no remaining changes in your selection.
                    Choose different items, or close this dialog and use
                    <span class="no-retry-payload-banner-action">Retry Full Update</span>.
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <app-shared-button (click)="showModal = false" class="cancel">Cancel</app-shared-button>
          @if (!retryStockUpdate) {
            <app-shared-button
              (click)="getSwappedSelectedChanges()"
              class="revert">
              Revert
            </app-shared-button>
          }
          @if (retryStockUpdate) {
            <app-shared-button
              (click)="retrySelectedChanges()"
              class="revert"
              [disabled]="!hasRetryPayload()">
              Confirm Retry
            </app-shared-button>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="notification-loader">
    <app-shared-loading-g
      [animation]="animation">
    </app-shared-loading-g>
  </div>
}

